import * as tslib_1 from "tslib";
import React from 'react';
import DialogPopup from '../Dialog';
import ConfirmationPopupFooter from './ConfirmationPopupFooter';
import s from './BaseConfirmationPopup.scss';
export var BaseConfirmationPopup = function (_a) {
    var isOpen = _a.isOpen, title = _a.title, onCancel = _a.onCancel, children = _a.children, confirmButtonLabel = _a.confirmButtonLabel, confirmButtonType = _a.confirmButtonType, confirmDisabled = _a.confirmDisabled, cancelButtonLabel = _a.cancelButtonLabel, onDone = _a.onDone;
    return (React.createElement(DialogPopup, { isOpen: isOpen, rootClassName: s['root'], headerClassName: s['header'], titleClassName: s['title'], contentClassName: s['content'], footerClassName: s['footer'], title: title, footer: React.createElement(ConfirmationPopupFooter, tslib_1.__assign({}, {
            confirmButtonLabel: confirmButtonLabel,
            confirmButtonType: confirmButtonType,
            confirmDisabled: confirmDisabled,
            cancelButtonLabel: cancelButtonLabel,
            onCancel: onCancel,
            onDone: onDone,
        })), onClose: onCancel }, children));
};
BaseConfirmationPopup.displayName = 'BaseConfirmationPopup';
export default BaseConfirmationPopup;
//# sourceMappingURL=BaseConfirmationPopup.js.map